// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "homepage/static/js/" + chunkId + "." + {"44":"4dbd9912","133":"1f466d1e","581":"7f8686ab","858":"337af333","872":"3dc3693f","975":"6bf37b1a"}[chunkId] + ".chunk.js";
};